package org.example.project.engineslot

import org.example.project.enginekartei.KarteiApi
import org.example.project.setup.SetupApi
import org.example.project.setup.SetupNodeApi
import org.example.project.utils.All

object SlotStammdatenApi {
    suspend fun loadStandortQuellen(): List<All> {
        val firmenId = SlotSnapCompanyApi.currentFirmenId()
        return loadStandortQuellen(firmenId)
    }

    suspend fun loadStandortQuellen(firmenId: String): List<All> {
        val normalizedFirmenId = firmenId.trim()
        val deckblatt = runCatching {
            if (normalizedFirmenId.isBlank()) null else SetupApi.loadCusDeckblatt(normalizedFirmenId)
        }.getOrNull()
        val standorte = runCatching {
            if (normalizedFirmenId.isBlank()) KarteiApi.loadStandorte()
            else SetupNodeApi.loadStandorte(normalizedFirmenId)
        }.getOrDefault(emptyList())
        
        return standorte
            .sortedBy { it.id.toIntOrNull() ?: Int.MAX_VALUE }
            .map { standort ->
                standort.copy(
                    firmenId = standort.firmenId.ifBlank { normalizedFirmenId },
                    firma = standort.firma.ifBlank { deckblatt?.firma.orEmpty() },
                    geschaeftsfuehrer = standort.geschaeftsfuehrer.ifBlank { deckblatt?.geschaeftsfuehrer.orEmpty() },
                    webseite = standort.webseite.ifBlank { deckblatt?.webseite.orEmpty() },
                    gegruendetAm = standort.gegruendetAm.ifBlank { deckblatt?.gegruendetAm.orEmpty() },
                    standort = standort.standort
                )
            }
    }

    suspend fun loadStandortQuellen(context: SlotCompanyContext): List<All> =
        loadStandortQuellen(context.firmenId)
}
